import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

/**
 * Generated class for the BranchLocatorPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-branch-locator',
  templateUrl: 'branch-locator.html',
})
export class BranchLocatorPage {
branches:any;
cities:any;
city:any="Mumbai";
  constructor(public loadingCtrl: LoadingController,public navCtrl: NavController, public navParams: NavParams,private cp: CommonProvider) {
  }

  ionViewDidLoad() {
    //////console.log('ionViewDidLoad BranchLocatorPage');
    this.city='Mumbai'
    this.getCity()
    this.getBranches("Mumbai");
  }
  getBranches(city){

  let loading = this.loadingCtrl.create({
     
    content: `Please wait...`,
    duration: 5000
  });
  loading.present();
  let request:any={};
  request.city = city;
  let data = this.cp.branchLocator(loading,request) ;
  data.then((res:any)=>{
    loading.dismiss();
     // var res=JSON.parse(res) 
     //console.log(res);
     this.branches = res;
     this.city=city
     //////console.log(res);
    
     
  })
}
getCity(){
  
  let loading = this.loadingCtrl.create({
     
    content: `Please wait...`,
    duration: 5000
  });
  loading.present();
  let data = this.cp.branchCity(loading) ;
  data.then((res:any)=>{
    loading.dismiss();
     // var res=JSON.parse(res) 
     //console.log(res);
     this.cities = res;
     
    
     
  })
}

}



// WEBPACK FOOTER //
// ./src/pages/branch-locator/branch-locator.ts